// removed by extract-text-webpack-plugin
module.exports = {"searchPageHeader":"_3H0Nm"};